import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useCreateLibraryMutation } from '../../../generated/graphql';
import { FormField, FormTextArea } from '../../form';
import styles from './NewLibraryDialog.module.css';

type NewLibraryDialogProps = {
    onClose: () => void,
    clientId: string | undefined | null,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const NewLibraryDialog = (props: NewLibraryDialogProps) => {
    const { style, visible, clientId, onClose } = props;
    const [createLibrary, createLibraryResult] = useCreateLibraryMutation();
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [validationError, setValidationError] = useState('');

    const handleSubmit = async () => {
        if (!name || !description) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        setValidationError('');
        try {
            await createLibrary({
                variables: {
                    library: { name, description, clientId }
                }
            });
            onClose();
        } catch (error) {
            setValidationError(error instanceof Error ? error.message : 'Unable to create the library.');
        }
    };

    return (
        <DialogBase
            isLoading={createLibraryResult.loading}
            title="New Library"
            type='OkCancel'
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            visible={visible}
            className={styles.NewLibraryDialog}
            style={style}
            data-testid="NewLibraryDialog">
            <FormField label="Library Name" name="name" value={name} onChange={setName} />
            <FormTextArea label="Description" name="description" value={description} onChange={setDescription} />
        </DialogBase>
    );
};

export default NewLibraryDialog;